"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenuItems = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const react_2 = require("@headlessui/react");
function AccountMenuItems(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (react_1.default.createElement(react_2.Menu.Items, Object.assign({ as: "ul", className: (0, classnames_1.default)('relative mt-3 px-6 pb-3 bg-white transform flex flex-col justify-start items-start', className) }, props),
        children,
        react_1.default.createElement("aside", { className: "absolute w-4 h-4 bg-white transform rotate-45 -z-1 -top-1 right-2.5" })));
}
exports.AccountMenuItems = AccountMenuItems;
